import { ProjectData } from "src/app/services/response-models/projects.response.model";

export class SaveCurrentProject {
    public static readonly type = "[Projects] Save current project";

    constructor(public payload: ProjectData) {}
}
